// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"af2a513c","242":"71e89988","667":"e57dd0ca","807":"af2a513c","827":"99155f0f"}[chunkId] + ".chunk.css";
};